import { z } from "zod";

export const CompanySchema = z.object({
  id: z.number(),
  name: z.string(),
});

export const MemberTypeSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const CitiesSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const TradesSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const YearsSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const DashboardFiltersFormSchema = z.object({
  company: CompanySchema.optional(),
  memberType: MemberTypeSchema.optional(),
  cities: z.array(CitiesSchema).optional(),
  trades: z.array(TradesSchema).optional(),
  years: z.array(YearsSchema).optional(),
});

export type MemberTypeOption = z.infer<typeof MemberTypeSchema>;

export type DashboardFiltersFormData = z.infer<
  typeof DashboardFiltersFormSchema
>;

export const MEMBER_TYPE_OPTIONS: MemberTypeOption[] = [
  { id: "both", name: "Both" },
  { id: "residential", name: "Residential" },
  { id: "commercial", name: "Commercial" },
];

export const DEFAULT_MEMBER_TYPE = MEMBER_TYPE_OPTIONS[0];
